import { rest } from "msw";
import { mockOrderProducts, mockOrders } from "./order.mocks";
const orderConfirmHandlers = [
    rest.get("/order/confirm/commercial", (_req, res, ctx) => {
        return res(ctx.status(200), ctx.json(mockOrders));
    }),
    rest.get("/order/confirm/commercial/:id", (req, res, ctx) => {
        const orderId = Number(req.params.id);
        if (isNaN(orderId)) {
            return res(ctx.status(400), ctx.json({ message: "유효하지 않은 ID입니다." }));
        }
        const order = mockOrders.find((order) => order.id === orderId);
        if (!order) {
            return res(ctx.status(404), ctx.json({ message: "존재하지 않는 발주서입니다." }));
        }
        return res(ctx.status(200), ctx.json([order]));
    }),
];
const orderProductHandlers = [
    rest.get("/order/product/commercial", (req, res, ctx) => {
        const url = new URL(req.url);
        const orderId = Number(url.searchParams.get("orderId"));
        let orderProducts = [...mockOrderProducts];
        if (orderId) {
            orderProducts = orderProducts.filter((product) => product.orderId === orderId);
        }
        if (isNaN(orderId)) {
            return res(ctx.status(400), ctx.json({ message: "유효하지 않은 ID입니다." }));
        }
        if (!orderProducts) {
            return res(ctx.status(404), ctx.json({ message: "존재하지 않는 발주 제품입니다." }));
        }
        return res(ctx.status(200), ctx.json(orderProducts));
    }),
];
export const orderHandlers = [...orderConfirmHandlers, ...orderProductHandlers];
